import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  AuthenticatedUser,
  ChangePasswordInput,
  LoginInput,
  LoginResponse,
} from '@marketing-os/shared';
import { apiGet, apiPost } from '@/lib/api';
import { qk } from '@/lib/queryClient';
import { useAuthStore } from '@/stores/auth.store';

export function useLogin() {
  const setSession = useAuthStore((state) => state.setSession);
  return useMutation({
    mutationFn: (input: LoginInput) => apiPost<LoginResponse, LoginInput>('/auth/login', input),
    onSuccess: (data) => setSession(data),
  });
}

/** Revalida o usuário (permissões podem ter mudado desde o último login). */
export function useMe(enabled: boolean) {
  const setUser = useAuthStore((state) => state.setUser);
  return useQuery({
    queryKey: qk.me,
    queryFn: async () => {
      const user = await apiGet<AuthenticatedUser>('/auth/me');
      setUser(user);
      return user;
    },
    enabled,
    staleTime: 5 * 60_000,
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (input: ChangePasswordInput) =>
      apiPost<void, ChangePasswordInput>('/auth/change-password', input),
  });
}
